import { render, staticRenderFns } from "./ClazzShowHeader.vue?vue&type=template&id=6fbbee51&scoped=true&"
import script from "./ClazzShowHeader.vue?vue&type=script&lang=js&"
export * from "./ClazzShowHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClazzShowHeader.vue?vue&type=style&index=0&id=6fbbee51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbbee51",
  null
  
)

export default component.exports